import { useState } from "react";

/**
 * throw errors from compoents that are caught by ErrorBoundary.
 * https://www.developerway.com/posts/how-to-handle-errors-in-react
 * @returns
 */
export const useThrowAsyncError = () => {
  const [state, setState] = useState();

  return (error: Error) => {
    setState(() => {
      throw error;
    });
  };
};
